module.exports = __webpack_public_path__ + "img/MES11Indice2_cutout.e2519dad.png";